var websiteConfig = process.env;
const currentURL = window.location.href
const hostname = new URL(currentURL).hostname
const subdomain = hostname.split('.')[0]
const extractedSubdomain = (() => {
    let postfixToRemove = process.env.REACT_APP_SUB_DOMAIN_POSTFIX
    // Remove protocol and www (if present)
    let currentURL = window.location.href
    let hostname = new URL(currentURL).hostname
    let subdomain = hostname.split('.')[0]
    // Remove postfix from subdomain
    if (postfixToRemove && subdomain.endsWith(postfixToRemove)) {
      subdomain = subdomain.slice(0, -postfixToRemove.length);
    }
    return subdomain;
  })();

  // console.log(process.env, subdomain, extractedSubdomain);
  websiteConfig = {
    "SubDomain": subdomain,
    "extractedSubdomain": extractedSubdomain,
    "SystemUrl": (process.env.REACT_APP_BACKEND_URL+"admin/").replace("*",subdomain+"-api"),
    "FrontUrl": process.env.REACT_APP_FRONT_URL.replace("*",subdomain),
    "BackendUrl": process.env.REACT_APP_BACKEND_URL.replace("*",subdomain+"-api"),
    "allowRequestIntercepts": process.env.REACT_APP_ALLOW_REQUEST_INTERCEPTS,
    "SaasUrl": process.env.REACT_APP_SAAS_URL,
    "Saas": process.env.REACT_APP_SAAS

  }

// websiteConfig["SubDomain"] = subdomain;
// websiteConfig["extractedSubdomain"] = extractedSubdomain;
// websiteConfig["SystemUrl"] = (process.env.REACT_APP_BACKEND_URL+"/admin/").replace("*",subdomain+"-api")
// websiteConfig["FrontUrl"] = process.env.REACT_APP_FRONT_URL.replace("*",subdomain)
// websiteConfig["BackendUrl"] = process.env.REACT_APP_BACKEND_URL.replace("*",subdomain+"-api")

export default websiteConfig
